// extracted by mini-css-extract-plugin
module.exports =  {"select":"lnmiQqgszcnn2mfeHUYF"};